export function formatCurrency(
  amount: number | string,
  currency?: string | null,
  locale?: string
): string {
  const n = typeof amount === 'string' ? Number(amount) : amount;
  const value = Number.isFinite(n) ? Number(n) : 0;
  const c = currency != null ? String(currency).trim().toUpperCase() : '';

  if (c) {
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: c,
        currencyDisplay: 'symbol',
      }).format(value);
    } catch {
      // fall through
    }
  }

  const fixed = value.toFixed(2);
  return c ? `${fixed} ${c}` : fixed;
}

